"use client";

import { Close } from "@faire/slate/icons/Close";
import { ButtonBase } from "@faire/slate/private/button/ButtonBase";
import { ButtonIcon } from "@faire/slate/private/button/ButtonIcon";
import { useHandleKeyDown } from "@faire/slate/private/hooks/useHandleKeyDown";
import { useStrictLocalization } from "@faire/web/common/localization";
import { cn } from "@faire/web/tools/cn";
import React, { useRef } from "react";

interface IProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  onClick?: () => void;
}

export const ToastCloseButton: React.FC<React.PropsWithChildren<IProps>> = ({
  onClick,
  children,
  className,
  ...props
}) => {
  const buttonRef = useRef<HTMLButtonElement>(null);
  const { strictLocalize } = useStrictLocalization();

  useHandleKeyDown({
    Escape: () => onClick?.(),
  });

  return (
    <ButtonBase
      className={cn("fs-icon-button--x-small", className)}
      onClick={onClick}
      aria-label={strictLocalize({
        id: "j/EWa/",
        defaultMessage: "Close notification",
        description: {
          text: "Screen reader label for a close button in a notification",
        },
      })}
      {...props}
      ref={buttonRef}
    >
      <ButtonIcon Icon={Close} titleAccess="" />
    </ButtonBase>
  );
};
